import { render, staticRenderFns } from "./ResMng.vue?vue&type=template&id=aba78160&scoped=true&"
import script from "./ResMng.vue?vue&type=script&lang=js&"
export * from "./ResMng.vue?vue&type=script&lang=js&"
import style0 from "./ResMng.vue?vue&type=style&index=0&id=aba78160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba78160",
  null
  
)

export default component.exports